import axios from 'axios';

const instance = axios.create({
  baseURL:
    window.location.host === 'localhost:3001'
      ? 'https://dev.sixtix.nl'
      : window.location.origin,
});

export default instance;
